import PropTypes from 'prop-types'
import {Flex, VStack} from '@chakra-ui/react'
import useSWRImmutable from 'swr/immutable'

import {fetcher} from '~/api'
import {camelizeResult} from '~/api/serializer'
import Loading from '~/react/components/Loading'
import RedemptionPartnerCard from './RedemptionPartnerCard'
import {usePermissions} from '../../hooks/usePermissions'

const PartnersTab = ({currentSupplier}) => {
  const {data: permissionsData} = usePermissions()
  const {connectRedemptionPartner} = permissionsData || {}

  // Fetch redemption partners
  const {data: partnersData, mutate: refreshPartnerData} = useSWRImmutable(
    `/points/api/suppliers/${currentSupplier.id}/redemption_partners`,
    fetcher,
    {
      use: [camelizeResult],
      suspense: true,
    },
  )

  const {redemptionPartners = []} = partnersData || {}

  return (
    <Loading>
      <VStack spacing={6} align="stretch">
        <Flex
          flexWrap="wrap"
          flexDirection={{base: 'column', md: 'row'}}
          gap="md"
        >
          {redemptionPartners.map((partner) => (
            <RedemptionPartnerCard
              key={partner.id}
              partner={partner}
              currentSupplier={currentSupplier}
              onConnectionSuccess={refreshPartnerData}
              onRedeemSuccess={refreshPartnerData}
              setupRequired={!connectRedemptionPartner}
            />
          ))}
        </Flex>
      </VStack>
    </Loading>
  )
}

PartnersTab.propTypes = {
  currentSupplier: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default PartnersTab
